import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Eye, Search } from "lucide-react";
import { Input } from "../../../components/ui/input";
import ThemeTable from "../../../components/Table/ThemeTable";
import { useNavigate } from "react-router";
import { useMediaQuery } from "@mui/material";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import { getAllEmployee } from "../../../services/apiservices/employee";
import moment from "moment";
import CommonContext from "../../../hooks/commonContext";

const ManageUsers = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:767px)");
  const commonContext = useContext(CommonContext)
  const [allUsersDetails, setAllUserDetails] = useState();

  const columns = [
    {
      id: "user",
      numeric: false,
      disablePadding: false,
      label: "User",
      isSortable: true,
      gray: true,
      className: "pl-20",
    },
    {
      id: "company",
      numeric: false,
      disablePadding: false,
      label: "Company",
      isSortable: true,
      gray: true,
    },
    {
      id: "role",
      numeric: false,
      disablePadding: false,
      label: "Role",
      isSortable: true,
      gray: true,
    },
    {
      id: "created",
      numeric: false,
      disablePadding: false,
      label: "Date Created",
      isSortable: true,
      gray: true,
    },
    {
      id: "activity",
      numeric: false,
      disablePadding: false,
      label: "Last Activity",
      isSortable: true,
      gray: true,
    },
    {
      id: "type",
      numeric: false,
      disablePadding: false,
      label: "Type",
      isSortable: true,
      gray: true,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      isSortable: true,
      gray: true,
    },
    {
      id: "actions",
      numeric: false,
      disablePadding: false,
      label: "Actions",
      isSortable: true,
      gray: true,
    },
  ];

  const fetchUsers = async () => {
    try {
      commonContext?.setLoader(true);
      const [usersRes] = await Promise.all([
        new Promise((resolve, reject) => getAllEmployee(resolve, reject)),
      ]);
      const userData = usersRes?.data?.filter(
        (item) => item?.role !== "companyUser" && item?.role !== "superUser"
      );

      const newData = (userData || [])?.map((item) => {
        const companyData = usersRes?.data?.find(
          (items) => items?.id === item?.companyId
        );
          let normalizedRole = "";
          if (Array.isArray(item?.role)) {
            if (item.role.includes("Employee")) {
              normalizedRole = item.employeerole === "Admin" ? "Team Admin" : item.employeerole || "Employee";
            } else if (item.role.includes("admin")) {
              normalizedRole = "Sys. Admin";
            } else {
              normalizedRole = item.role[0];
            }
          } else {
            if (item?.role === "Employee") {
              normalizedRole = item?.employeerole === "Admin" ? "Team Admin" : item?.employeerole || "Employee";
            } else if (item?.role === "admin") {
              normalizedRole = "Sys. Admin";
            } else {
              normalizedRole = item?.role;
            }
          }
        return {
          ...item,
          name: `${item.firstName} ${item.lastName}`,
          email: item.email,
          role: normalizedRole,
          contact: item?.phoneNumber ? item?.phoneNumber : item?.phone,
          type:
             (Array.isArray(item?.role) ? item.role.includes("Employee") : item?.role === "Employee") && item?.employeerole === "Client Team"
              ? "mobile"
              : "web",
          // company: `${companyData?.firstName} ${companyData?.lastName}`,
          company: companyData?.companyName,
        };
      });
      const sortedData = sortingFunction(newData);
      setAllUserDetails(sortedData);
      commonContext?.setLoader(false);
    } catch (error) {
      console.error("Error in fetching data:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.company < b.company) return -1;
      if (a.company > b.company) return 1;

      if (a.role < b.role) return -1;
      if (a.role > b.role) return 1;

      return 0;
    });

    return result;
  };

  const getUserTypeBadgeColor = (userType) => {
    return userType === "mobile"
      ? "bg-purple-100 text-purple-800"
      : "bg-blue-100 text-blue-800";
  };

  const getRoleBadgeColor = (role) => {
    switch (role?.toLowerCase()) {
      case "sys. admin" || "team admin":
        return "bg-green-500 hover:bg-green-600";
      case "client team":
        return "bg-blue-500 hover:bg-blue-600";
      case "support":
        return "bg-gray-500 hover:bg-gray-600";
      case "client":
        return "bg-purple-500 hover:bg-puple-500";
      default:
        return "bg-slate-500 hover:bg-slate-600";
    }
  };

  const handleNaviage = (id) => {
    navigate(`/manageUsersDetails/${id}`)
  }

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem?.id) {
      case "type":
        return (
          <Badge
            className={`${getUserTypeBadgeColor(rcellItem?.type)} text-xs`}
            style={{ borderRadius: "6px" }}
          >
            {rcellItem?.type}
          </Badge>
        );
      case "user":
        return (
          <div className="d-flex flex-direction-column">
            <span
              className="ph-10"
              style={{ fontSize: "14px", fontWeight: "500" }}
            >
              {rcellItem?.name}{" "}
            </span>
            <span
              className="mt-3 ph-10"
              style={{ fontSize: "14px", fontWeight: "400", color: "#6B7280" }}
            >
              {rcellItem?.email}{" "}
            </span>
            <span
              className="mt-3 ph-10"
              style={{ fontSize: "14px", fontWeight: "400", color: "#6B7280" }}
            >
              {rcellItem?.contact}{" "}
            </span>
          </div>
        );
      case "company":
        return <span> {rcellItem?.company} </span>;
      case "created":
        return (
          <span>
            {moment(rcellItem?.createdAt).format("MMMM D, YYYY")}
          </span>
        );
      case "role":
        return (
          <Badge
            variant={"info"}
            className={`${getRoleBadgeColor(rcellItem?.role)} text-xs`}
            style={{ borderRadius: "6px" }}
          >
            {rcellItem?.role}
          </Badge>
        );
      case "status":
        return (
          <Badge
            variant={rcellItem?.status ? "default" : "inactive"}
            className="text-xs"
            style={{ borderRadius: "6px" }}
          >
            {rcellItem?.status ? "Active" : "Inactive"}
          </Badge>
        );
      case "actions":
        return (
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleNaviage(rcellItem?.id)}
          >
            <Eye className="h-4 w-4 mr-4" />
            Details
          </Button>
        );
    }
  };


  const checkRowSearch = (searchTerm, row) => {
      const lowerSearch = String(searchTerm).toLowerCase();
    return (
      String(row?.email)?.toLowerCase()?.includes(lowerSearch) ||
      String(row?.name)?.toLowerCase()?.includes(lowerSearch) ||
      String(row?.role)?.toLowerCase()?.includes(lowerSearch) ||
      String(row?.company)?.toLowerCase()?.includes(lowerSearch) ||
      String(row?.contact)?.toLowerCase()?.includes(lowerSearch)
    );
  };
  const filteredUsers = allUsersDetails?.filter((item) => {
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;
    
    return matchesSearch;
  });


  return (
    <div className="container mx-auto px-3 md:px-4 py-4 md:py-8">
      <div className="mb-16 md:mb-24">
        <h1 className="text-xl md:text-2xl font-bold mb-8 text-foreground">System Users</h1>
        <p className="text-gray-600 dark:text-gray-400">
          Manage all users across the platform
        </p>
      </div>

      <Card className="bg-white dark:bg-[#2c3440] mb-24 p-24">
        <CardHeader>
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <div className="relative flex-1 max-w-md">
              <Search
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                size={18}
              />
              <Input
                placeholder="Search users by name, email, company, or role..."
                className="pl-40"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
              <span>Total Users: {allUsersDetails?.length}</span>
              <span>
                Active:{" "}
                {allUsersDetails?.filter((user) => user.status === true).length}
              </span>
              <span>
                Inactive:{" "}
                {allUsersDetails?.filter((user) => user.status !== true).length}
              </span>
            </div>
          </div>
        </CardHeader>
      </Card>

      <Card className="bg-white dark:bg-[#2c3440]">
        <CardHeader className="pb-16 ph-24 pt-24">
          <CardTitle className="text-base md:text-lg">
            All System Users
          </CardTitle>
        </CardHeader>
        <CardContent>
          {isMobile ? (
            <div className="space-y-4 ph-12">
              {filteredUsers?.map((user) => (
                <Card key={user?.id} className="p-16 border border-gray-200 dark:border-gray-700">
                  <div className="space-y-3">
                    <div className="flex justify-between items-start">
                      <div>
                        <h4 className="font-medium text-sm">{user?.name}</h4>
                        <p className="text-xs text-gray-500">{user?.email}</p>
                        <p className="text-xs text-gray-500">{user?.contact}</p>
                      </div>
                      <div className="flex flex-col gap-1">
                        <Badge
                          variant={"info"}
                          className={`${getRoleBadgeColor(user?.role)} text-xs`}
                          style={{ borderRadius: "6px" }}
                        >
                          {user?.role}
                        </Badge>
                        <Badge
                          variant="outline"
                          className={`${getUserTypeBadgeColor(
                            user?.type
                          )} text-xs`}
                          style={{ borderRadius: "6px" }}
                        >
                          {user?.type}
                        </Badge>
                      </div>
                    </div>

                    <div className="border-t border-gray-100 dark:border-gray-700 pt-3 space-y-2">
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Company:</span>
                        <span className="truncate ml-8">{user?.company}</span>
                      </div>
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Created:</span>
                        <span>
                          {moment(user?.createdAt).format("MMMM D, YYYY")}
                        </span>
                      </div>
                      {/* <div className="flex justify-between text-xs">
                          <span className="text-gray-500">Last Active:</span>
                          <span>{formatDateTime(user?.lastActivity)}</span>
                        </div> */}
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-500">Status:</span>
                        <Badge
                          variant={user?.status ? "default" : "inactive"}
                          className="text-xs"
                          style={{ borderRadius: "6px" }}
                        >
                          {user?.status ? "Active" : "Inactive"}
                        </Badge>
                      </div>
                    </div>

                    <div className="border-t border-gray-100 dark:border-gray-700 pt-12">
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full flex items-center gap-2"
                        onClick={() => handleNaviage(user?.id)}
                      >
                        <Eye size={14} />
                        View Details
                      </Button>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <ThemeTable
                rows={filteredUsers}
                headCells={columns}
                renderRowCell={renderRowCell}
                hidePagination={false}
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ManageUsers;
